import styled from 'styled-components';
import Checkbox from '../../components/Checkbox';

export const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  h1 {
    font-weight: 600;
    font: 24px Montserrat;
    color: #000000;
  }

  .body-wrapper {
    overflow-y: auto;
    padding-top: 32px;
    padding-left: 32px;
    padding-right: 32px;
    padding-bottom: 1rem;
  }
`;

export const Subtitle = styled.p`
  font-size: 16px;
  font-weight: 500;
  text-align: left;
  color: #898b8e;

  margin-top: 32px;
  margin-bottom: 24px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-top: auto;
`;

export const CheckWrapper = styled.div`
  padding-top: 20px;
`;

export const CustomCheck = styled(Checkbox)`
  display: flex;
  justify-content: center;
  cursor: pointer;
  gap: 14px;
  align-items: baseline;
`;
